import { memo } from "react";
const FacilityCards = memo(({cards}) => {
  return (
    <ul className="info-block-list__cards">
      {cards.map((card) => {
        return (
          <li key={card.cardId}>
            <img src={card.thumbnailURL} loading="lazy" alt={`${card.name ? card.name +'card image' : 'card image'}`} width="27" height="17" />
          </li>
        );
      })}
    </ul>
  );
});
export default FacilityCards;
